import React from "react"

const Footer = () => {

    return (
        <h5 className="copyright">Intelius © Copyright 2020</h5>
    )
}

export default Footer